import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Button, IconButton} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none'
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row'
  },
  iconButton: {
    color: theme.palette.secondary.dark
  }
}));

const Topbar = props => {
  const { className, user, onLogout, ...rest } = props;
  const history = useHistory();

  const classes = useStyles();

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/" style={{flexGrow:1}}>
          <img
            alt="Logo"
            src="/images/logos/logo.svg"
            width={180}
          />
        </RouterLink>
        <RouterLink to="/playlist-search" style={{flexGrow:1}}>
          <Button> 
            <DashboardIcon/> Playlist Search
          </Button>
        </RouterLink>
        { typeof(user)==='object' ? 
          <Button
            color={classes.iconButton}
            onClick={(e)=>{e.preventDefault();onLogout(history)}}
          >
            <InputIcon />
          </Button>
          :
          <div>
            <RouterLink to="/sign-in">
              <Button> Login </Button>
            </RouterLink>
            <RouterLink to="/sign-up">
              <Button> Register </Button>
            </RouterLink>
          </div>
        }
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string
};

export default Topbar;
